define('chartApi/exportingApi',['knockout', 'lodash', 'jquery'], function(ko, _, $) {
    'use strict';

    return {
        htmlFromHighcharts: htmlFromHighcharts,
        csvFromHighcharts: csvFromHighcharts,
        dataRowsFromHighcharts: dataRowsFromHighcharts
    };


    /**
     * @param  {Element Html element encapsulating the highcharts }
     * @return {String the inerHtml string basically a stringified HTML Table}
     */
    function htmlFromHighcharts(chartContainer) {
        var highchartObj = $(chartContainer).highcharts();
        var innerHtml = '';
        var dataRows = dataRowsFromHighcharts(highchartObj, 'html');
        innerHtml = htmlTableFromDataRows(dataRows);
        return innerHtml;
    }

    /**
     * @param  {Element  Html element encapsulating the highcharts }
     * @return {String the CSV string of the chart Data}
     */
    function csvFromHighcharts(chartContainer) {
        var highchartObj = $(chartContainer).highcharts();
        var csvString = '';
        var dataRows = dataRowsFromHighcharts(highchartObj, 'csv');
        return csvStringFromDataRows(dataRows);
    }

    /**
     * [htmlTableFromDataRows description]
     * @param  {[type]} dataRows [description]
     * @return {[type]}          [description]
     */
    function htmlTableFromDataRows(dataRows) {

        var tags;
        var noOfCol = dataRows[0].length;

        var htmlStr = '<table class="table table-bordered table-hover" atn-cols="' + noOfCol + '">';

        _.forEach(dataRows, function(dataRow, rowIndex) {
            htmlStr += '<tr>';
            tags = rowIndex ? ['<td>', '</td>'] : ['<th>', '</th>'];

            _.forEach(dataRow, function(rowElem) {
                htmlStr += (tags[0] + rowElem + tags[1]);
            });

            htmlStr += '</tr>';
        });

        htmlStr += '</table>';

        return htmlStr;
    }

    /**
     * [csvStringFromDataRows description]
     * @param  {[type]} dataRows [description]
     * @return {[type]}          [description]
     */
    function csvStringFromDataRows(dataRows) {
        var retCsvString = '';

        _.forEach(dataRows, function(dataRow, rowIndex) {
            retCsvString += dataRow.join(',');
            retCsvString += '\n';
        });

        return retCsvString;
    }


    /**
     * @param  {Object the highcharts object}
     * @return {Array an array of arrays containing the chart data.}
     */
    function dataRowsFromHighcharts(highchartObj, view) {
        var returnArr = [];
        var titleRow;
        var headerRow = [];
        var dataRows = [];
        var config = highchartObj.userOptions.dataTableConfig;
        var isPieChart = highchartObj.userOptions.isPie;

        //Iiterate over the x axis values; generally only one xAxis is present
        _.forEach(highchartObj.xAxis, function(axis) {
            addXAxisDurationData(axis, config, dataRows, headerRow);
        });

        //iterate over each of the data series.
        _.forEach(highchartObj.series, function(series) {
            var isAreaChart;
            //Set the header unit in this variable.
            if (config.removeHiddenSeries && series.userOptions.showInLegend === false) {
                _.noop;
            } else {
                isAreaChart = series.area;
                //data rows are allocated when there is xAxis data. For piecharts the dataRows will be empty array 
                //so populate the array indices.
                if (!dataRows.length) {
                    _.forEach(_.range(series.data.length), function() {
                        dataRows.push([]);
                    });
                }

                if (isPieChart) {
                    addpieChartSeriesData(series, config, dataRows, headerRow);
                } else if (isAreaChart) {
                    //This is for area charts.
                    addXAxisSeriesData(series, config, dataRows, headerRow);
                    addYAxisSeriesData(series, config, dataRows, headerRow);
                } else {
                    addYAxisSeriesData(series, config, dataRows, headerRow);
                }
            }
        });

        if (config.customDateString && view !== 'html') {
            titleRow = [config.customDateString];
            returnArr.push(titleRow);
        }

        returnArr.push(headerRow);
        returnArr = returnArr.concat(dataRows);

        return returnArr;
    }
    /**
     * [addXAxisDurationData description]
     * @param {[type]} axis      [description]
     * @param {[type]} config    [description]
     * @param {[type]} dataRows  [description]
     * @param {[type]} headerRow [description]
     */
    function addXAxisDurationData(axis, config, dataRows, headerRow) {
        //Push each value on the x axis to each data row element. This sets the columns of the data.
        if (axis.categories) {
            //push the acis title(header) to the header element of the table.
            headerRow.push(config.xAxisDataHeader);

            _.forEach(_.range(axis.categories.length), function(index) {
                var singleRow = [];
                var rowVal;
                if (config.chartType === 'topN') {
                    rowVal = config.xAxisFormatter ?
                        config.xAxisFormatter(config.xAxisMaxChars, axis.categories[index]) :
                        axis.categories[index];
                } else {
                    rowVal = config.xAxisFormatter ?
                        config.xAxisFormatter(config.duration, config.granularity, axis.categories[index]) :
                        axis.categories[index];
                }
                singleRow.push(rowVal);
                dataRows.push(singleRow);
            });
        }
    }

    /**
     * [addXAxisSeriesData description]
     * @param {[type]} series    [description]
     * @param {[type]} config    [description]
     * @param {[type]} dataRows  [description]
     * @param {[type]} headerRow [description]
     */
    function addXAxisSeriesData(series, config, dataRows, headerRow) {

        var headerUnit = null;
        var seriesDataMax = _.max(series.xData);

        _.forEach(_.range(series.data.length), function(index) {
            // Since the table is using the values shown on the UI the formatting
            // must be done according to the UI formatter.
            var dataValue;
            //null is special case when sync fails .. it has different meaning from 0.
            if (config.xAxisFormatter && series.data[index].x !== null) {
                dataValue = config.xAxisFormatter(
                    series.data[index].x,
                    seriesDataMax,
                    config.xAxisUnitObj,
                    config.xAxisBaseUnit,
                    config.xAxisRoundOff,
                    config.xAxisTrimDecimalPlaces);
            } else {
                dataValue = {
                    value: series.data[index].x,
                    unit: ''
                };
            }

            //set the unit once
            if (!headerUnit) {
                headerUnit = dataValue.unit;
            }
            //push the element to the respectove row.
            dataRows[index].push(dataValue.value === null ? 'N/A' : dataValue.value);
        });

        //set the headers alond with the units.
        if (headerUnit) {
            headerRow.push(config.xAxisDataHeader + headerUnit);
        } else {
            headerRow.push(config.xAxisDataHeader);
        }
    }

    /**
     * [addYAxisSeriesData description]
     * @param {[type]} series    [description]
     * @param {[type]} config    [description]
     * @param {[type]} dataRows  [description]
     * @param {[type]} headerRow [description]
     */
    function addYAxisSeriesData(series, config, dataRows, headerRow) {

        var headerUnit = null;
        var seriesDataMax = _.max(series.yData);

        _.forEach(_.range(series.data.length), function(index) {
            // Since the table is using the values shown on the UI the formatting
            // must be done according to the UI formatter.
            var dataValue;
            //null is special case when sync fails .. it has different meaning from 0.
            if (config.yAxisFormatter && series.data[index].y !== null) {
                dataValue = config.yAxisFormatter(
                    series.data[index].y,
                    seriesDataMax,
                    config.yAxisBaseUnit,
                    config.yAxisRoundOff,
                    config.yAxisTrimDecimalPlaces);
            } else {
                dataValue = {
                    value: series.data[index].y,
                    unit: ''
                };
            }

            //set the unit once
            if (!headerUnit) {
                headerUnit = dataValue.unit;
            }
            //push the element to the respectove row.
            dataRows[index].push(dataValue.value === null ? 'N/A' : dataValue.value);
        });

        //set the headers alond with the units.
        if (headerUnit) {
            headerRow.push(series.name + headerUnit);
        } else {
            headerRow.push(series.name);
        }
    }

    /**
     * [addpieChartSeriesData description]
     * @param  {[type]} series    [description]
     * @param  {[type]} config    [description]
     * @param  {[type]} dataRows  [description]
     * @param  {[type]} headerRow [description]
     * @return {[type]}           [description]
     */
    function addpieChartSeriesData(series, config, dataRows, headerRow) {
        var headerUnit = null;
        var yDataMax = _.max(series.yData);

        _.forEach(_.range(series.data.length), function(index) {

            dataRows[index].push(series.data[index].name);

            // Since the table is using the values shown on the UI the formatting
            // must be done according to the UI formatter.
            var dataValue;
            //null is special case when sync fails .. it has different meaning from 0.
            if (config.yAxisFormatter && series.data[index].y !== null) {
                dataValue = config.yAxisFormatter(
                    series.data[index].y,
                    yDataMax,
                    config.yAxisBaseUnit,
                    config.yAxisRoundOff,
                    config.yAxisTrimDecimalPlaces);
            } else {
                dataValue = {
                    value: series.data[index].y,
                    unit: ''
                };
            }

            //set the unit once
            if (!headerUnit) {
                headerUnit = dataValue.unit;
            }
            //push the element to the respectove row.
            dataRows[index].push(dataValue.value === null ? 'N/A' : dataValue.value);
            dataRows[index].push(series.data[index].percentage.toFixed(2) + '%');
        });

        headerRow.push(config.nameHeader);

        //set the headers alond with the units.
        if (headerUnit) {
            headerRow.push(config.yHeader + headerUnit);
        } else {
            headerRow.push(config.yHeader);
        }

        headerRow.push(config.percentageHeader);
    }

});

